module.exports = {
      id: "logo-usage",
      viewBox: "0 0 997.64 195.19",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#logo",
      toString: function () {
        return this.url;
      }
    }